import { combineReducers, createStore } from "@reduxjs/toolkit";
import globalReducer from "./globalReducer";
import transactionReducer from "./transactionReducer";

export const store = createStore(
  combineReducers({ global: globalReducer, trans: transactionReducer })
);
